module.exports = __webpack_public_path__ + "img/acounto_logo-03n.9b2cf1ca.svg";